// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"27d524d4","147":"53108ea6","171":"0ca1b0a7","374":"aba8c2f8","429":"91d0fddf","466":"6d657303","507":"9bb6d273","641":"d437ad5a","780":"38384336"}[chunkId] + ".chunk.js";
};